module.exports = __webpack_public_path__ + "e6fd95f0cb839566476ec9b6df34849c.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/css/fonts/RobotoCondensed-Regular.ttf
 ** module id = 382
 ** module chunks = 0
 **/